const config = {
  isDebug: true,
  isOpenScreenSwitch: true, //开启pc端等比缩放
  baseCreenWidth: 1920, //等比缩放基础尺寸
}

export default config;